import { format } from "date-fns";
import { CheckCircle2, Circle } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import type { CrmUserMilestones } from "@/services/adminCrm";

interface Props {
  milestones: CrmUserMilestones;
}

const milestoneOrder: { key: keyof CrmUserMilestones; label: string }[] = [
  { key: "accountCreated", label: "Account Created" },
  { key: "firstSession", label: "First Session" },
  { key: "jgsLinked", label: "JGS Linked" },
  { key: "firstMessageSent", label: "First Message" },
  { key: "firstSchoolList", label: "First School List" },
  { key: "firstOutreachDrafted", label: "First Outreach Drafted" },
  { key: "firstOutreachSent", label: "First Outreach Sent" },
];

function formatDate(dateStr: string | null): string {
  if (!dateStr) return "";
  try {
    return format(new Date(dateStr), "MMM d, yyyy");
  } catch {
    return "";
  }
}

export function UserMilestonesSection({ milestones }: Props) {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-base">Milestones</CardTitle>
      </CardHeader>
      <CardContent>
        <ol className="space-y-2">
          {milestoneOrder.map(({ key, label }) => {
            const date = milestones[key];
            const completed = !!date;
            return (
              <li key={key} className="flex items-center gap-3 text-sm">
                {completed ? (
                  <CheckCircle2 className="h-4 w-4 text-green-600 shrink-0" />
                ) : (
                  <Circle className="h-4 w-4 text-muted-foreground shrink-0" />
                )}
                <span className={completed ? "text-foreground" : "text-muted-foreground"}>
                  {label}
                </span>
                {completed && (
                  <span className="text-xs text-muted-foreground ml-auto">{formatDate(date)}</span>
                )}
              </li>
            );
          })}
        </ol>
      </CardContent>
    </Card>
  );
}
